module.exports = __webpack_public_path__ + "static/media/profile.5e6b1480.png";